export default function useProvablyContent(obj) {
  const {
    client_seed,
    server_seed_SHA256,
    nonce,
    old_client_seed,
    old_server_seed,
    old_server_seed_SHA256,
    old_nonce,
    next_server_seed_SHA256,
  } = obj;

  const ProvFairTitle = {
    Title: "Explanation",
    Description: ` There are several implementations of the provably fair method, we
          will describe the most common one. With this method each roll-result
          is calculated by the following variables:`,
  };

  const ProvFairText = [
    {
      Title: "Serverseed",
      Description: `provided by the gambling site`,
    },
    {
      Title: "Nonce",
      Description: ` A number that increases with each random number is needed.`,
    },
    {
      Title: "Clientseed",
      Description: `provided by your browser and adjusted by you`,
    },
    {
      Title: "Hash",
      Description: `Encrypted data`,
    },
  ];

  const CurrentSeedPair = [
    {
      Title: "Clients Seed",
      Value: client_seed,
      Placeholder: "clients seed",
    },
    {
      Title: "Server seed hash",
      Value: server_seed_SHA256,
      Placeholder: "server seed hash",
    },
    {
      Title: "Nonce",
      Value: nonce,
      Placeholder: 0,
    },
    {
      Title: "Next server seed hash",
      Value: next_server_seed_SHA256,
      Placeholder: "next server seed hash",
    },
  ];
  const PreviousSeedPair = [
    {
      Title: "Clients Seed",
      Value: old_client_seed,
      Placeholder: "clients seed",
    },
    {
      Title: "Server seed",
      Value: old_server_seed,
      Placeholder: "server seed",
    },
    {
      Title: "Server seed hash",
      Value: old_server_seed_SHA256,
      Placeholder: "server seed hash",
    },
    {
      Title: "Nonce",
      Value: old_nonce,
      Placeholder: "nonce",
    },
  ];
  return { ProvFairText, ProvFairTitle, CurrentSeedPair, PreviousSeedPair };
}
